export default __webpack_public_path__ + "static/media/Widowdusk Belt.f0ff0170.jpg";